export default {
  data: function() {
    return {
      errors: {
        usernameInput: "",
        emailInput: "",
        passwordInput: "",
        websiteUrlInput: "",
        websiteNameInput: "",
        youtubeChannelUrlInput: ""
      }
    };
  },
  methods: {
    triggerInputAlert(alert) {
      for (let i = 0; i < alert.errors.length; i++) {
        this.errors[alert.errors[i].ref] = alert.errors[i].detail;
      }
    },
    removeInputErrorMessage(input) {
      this.errors[input] = "";
    },
    duplicateWebisteUrl() {
      this.errors.websiteUrlInput = "signUp.duplicateWebsiteUrl";
    },
    duplicateYoutubeChannelUrl() {
      this.errors.youtubeChannelUrlInput = "signUp.duplicateYoutubeChannelUrl";
    },
    messageAlertForNoWebsiteName() {
      this.errors.websiteNameInput = "signUp.pleaseAddWebsiteNameForWebsite";
    },
    removeMessageAlertForNoWebsiteName() {
      this.errors.websiteNameInput = "";
    }
  }
};
